import { useErrorBoundary } from 'react-error-boundary';

const StreamError = () => {
    const streamError = new Error('Stream error. Manually triggered.');
    const { showBoundary } = useErrorBoundary();

    return showBoundary(streamError);
};

export default StreamError;
